/**
 * Componente de Paginação Reutilizável
 * Fornece funcionalidades padronizadas para paginação infinita e busca
 */

/**
 * Configuração padrão para paginação
 */
const defaultPaginationConfig = {
    initialPage: 2,
    scrollThreshold: 0.9,
    loadingDelay: 0,
    minSearchLength: 3,
    loadingClass: "loadingPage",
    noDataClass: "textNoData",
    searchLoadingClass: "loadingSearch",
    dataNotFoundClass: "dataNotFound",
};

/**
 * Classe para gerenciar paginação infinita
 */
export class InfinitePagination {
    constructor(config) {
        this.config = { ...defaultPaginationConfig, ...config };
        this.page = this.config.initialPage;
        this.loading = false;
        this.searchActive = false;

        this.init();
    }

    init() {
        this.setupScrollListener();
        if (this.config.searchInput) {
            this.setupSearchListener();
        }
    }

    setupScrollListener() {
        $(window).on("scroll", () => {
            if (
                this.loading ||
                this.searchActive ||
                $(`.${this.config.dataNotFoundClass}`).is(":visible")
            ) {
                return;
            }

            const scrollPosition = $(window).scrollTop() + $(window).height();
            const documentHeight = $(document).height();
            const threshold = documentHeight * this.config.scrollThreshold;

            if (scrollPosition >= threshold) {
                this.loadMore();
            }
        });
    }

    setupSearchListener() {
        $(this.config.searchInput).on("keyup", (e) => {
            const value = $(e.target).val();
            this.handleSearch(value);
        });
    }

    loadMore() {
        if (this.loading) {
            return;
        }

        this.loading = true;
        this.showLoading();

        const url = this.buildUrl();

        // Obter parâmetros extras dinamicamente se configurado
        let extraParams = this.config.extraParams || {};

        // Verifica se existe getParams na configuração (passado via setupInfiniteScroll)
        if (
            this.config.getParams &&
            typeof this.config.getParams === "function"
        ) {
            try {
                const dynamicParams = this.config.getParams();
                if (dynamicParams) {
                    extraParams = { ...extraParams, ...dynamicParams };
                }
            } catch (e) {
                console.error("Erro ao obter parâmetros de filtro:", e);
            }
        }

        $.ajax({
            url: url,
            type: "GET",
            data: extraParams,
            success: (response) => {
                this.handleLoadSuccess(response);
            },
            error: (xhr, status, error) => {
                this.handleLoadError(xhr, status, error);
            },
            complete: () => {},
        });
    }

    buildUrl() {
        const baseUrl = this.config.loadUrl;
        const separator = baseUrl.includes("?") ? "&" : "?";
        return `${baseUrl}${separator}page=${this.page}`;
    }

    handleLoadSuccess(response) {
        if (response.execute && response.html && response.html.trim() !== "") {
            setTimeout(() => {
                $(this.config.container).append(response.html);

                if (response.total !== undefined) {
                    const totalForLabel = response.total;
                    this.updateCountDisplay(totalForLabel);
                }

                if (response.nextPage !== null) {
                    this.page = response.nextPage;
                    this.updatePageInput();
                    this.loading = false;
                    this.hideLoading();
                } else {
                    this.showNoMoreData();
                }
            }, this.config.loadingDelay);
        } else {
            this.showNoMoreData();
            this.page = -1;
        }
    }

    updateCountDisplay(total) {
        const rows = $(this.config.container).find("tr").length;
        const currentCount = rows;
        const countElement = $("#listing-count");
        if (countElement.length) {
            let text = countElement.text();
            const regex = /Exibindo\s+(\d+)\s+de\s+(\d+)/;

            let baseTotal = countElement.data("totalAllBase");

            // Se o total veio do servidor, atualizamos a base e usamos ele
            if (typeof total !== "undefined" && total !== null) {
                baseTotal = total;
                countElement.data("totalAllBase", baseTotal);
            }

            if (!baseTotal && regex.test(text)) {
                const match = text.match(regex);
                if (match && match[2]) {
                    baseTotal = parseInt(match[2], 10) || 0;
                    countElement.data("totalAllBase", baseTotal);
                }
            }

            const totalForLabel = baseTotal || total || currentCount;

            if (regex.test(text)) {
                const newText = text.replace(
                    /Exibindo\s+\d+\s+de\s+\d+/,
                    `Exibindo ${currentCount} de ${totalForLabel}`,
                );
                countElement.text(newText);
            }
        }
    }

    handleLoadError(xhr, status, error) {
        this.loading = false;
        this.showError("Erro ao carregar mais dados");
        this.hideLoading();
    }

    handleSearch(value) {
        $(`.${this.config.noDataClass}`).hide();
        $(`.${this.config.dataNotFoundClass}`).hide();

        if (value.length >= this.config.minSearchLength) {
            this.searchActive = true;
            $("body").addClass("loaded-search");
            this.performSearch(value);
        } else if (value.length === 0) {
            this.searchActive = false;
            $("body").removeClass("loaded-search");
            this.performSearch("");
        }
    }

    performSearch(searchValue) {
        $.ajax({
            url: this.config.searchUrl,
            type: "POST",
            data: { value: searchValue },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            beforeSend: () => this.showSearchLoading(),
            success: (response) => this.handleSearchSuccess(response),
            error: (xhr, status, error) =>
                this.handleSearchError(xhr, status, error),
            complete: () => this.hideSearchLoading(),
        });
    }

    handleSearchSuccess(response) {
        if (response.html && response.html.trim() !== "") {
            $(this.config.container).html(response.html);
        } else {
            $(this.config.container).empty();
            $(`.${this.config.dataNotFoundClass}`).show();
        }
    }

    handleSearchError(xhr, status, error) {
        this.showError("Erro na busca");
    }

    showLoading() {
        const $loading = $(`.${this.config.loadingClass}`);
        $loading.show();
        // Garantir que texto de carregamento apareça junto do spinner
        if ($loading.find(".pagination-loading-text").length === 0) {
            $loading.append(
                '<p class="pagination-loading-text">Carregando dados, aguarde...</p>',
            );
        }
    }

    hideLoading() {
        $(`.${this.config.loadingClass}`).hide();
    }

    showSearchLoading() {
        $(this.config.container).hide();
        $(`.${this.config.searchLoadingClass}`).show();
    }

    hideSearchLoading() {
        $(`.${this.config.searchLoadingClass}`).hide();
        $(this.config.container).show();
    }

    showNoMoreData() {
        $(`.${this.config.noDataClass}`).show();
        $(`.${this.config.loadingClass}`).hide();
        this.loading = true; // Impede novas requisições
    }

    showError(message) {
        // Implementar notificação de erro
    }

    updatePageInput() {
        if (this.config.pageInput) {
            $(this.config.pageInput).val(this.page);
        }
    }

    reset() {
        this.page = this.config.initialPage;
        this.loading = false;
        this.searchActive = false;
        $("body").removeClass("loaded-search");
    }
}

/**
 * Factory function para criar paginação simples
 */
export function createSimplePagination(config) {
    return new InfinitePagination(config);
}

/**
 * Função de conveniência para configuração rápida
 */
export function setupQuickPagination(
    container,
    loadUrl,
    searchInput = null,
    searchUrl = null,
    extraConfig = {},
) {
    const config = {
        container,
        loadUrl,
        searchInput,
        searchUrl,
        ...extraConfig,
    };

    return new InfinitePagination(config);
}

/**
 * Função para migrar código existente (compatibilidade)
 */
export function setupInfiniteScroll(container, loadUrl) {
    return setupQuickPagination(container, loadUrl);
}

/**
 * Função para configurar busca com paginação
 */
export function setupSearchWithPagination(
    container,
    loadUrl,
    searchInput,
    searchUrl,
) {
    return setupQuickPagination(container, loadUrl, searchInput, searchUrl);
}
